
<merkator-document-tabs
    [documents]="documents"
    [buttonLabel]="buttonLabel"
></merkator-document-tabs>